import Layout from '@/components/feature/Layout';
import { SEOHead } from '@/components/feature/SEOHead';
import { SchemaOrg } from '@/components/feature/SchemaOrg';
import HeroSection, { CategoryGrid, FeaturedArticles, FeaturesSection, FAQSection, CTASection } from './components/HomeSections';

export default function Home() {
  const websiteSchema = {
    '@type': 'WebSite',
    name: '含羞草研究院',
    url: 'https://www.mimosa-research.cn',
    description: '含羞草研究院是一个专注于知识探索、学习成长与自我提升的专业平台。',
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@type': 'Organization',
    name: '含羞草研究院',
    url: 'https://www.mimosa-research.cn',
    description: '专注于知识探索、学习成长与自我提升的专业研究平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@mimosa-research.cn',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const faqSchema = {
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '含羞草研究院适合什么样的人群？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '含羞草研究院适合所有渴望知识探索和自我提升的人，无论你是学生、职场人士还是终身学习者，这里都有适合你的内容和资源。',
        },
      },
      {
        '@type': 'Question',
        name: '平台上的内容是否免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们提供大量优质免费内容，包括文章、方法论和学习指南。部分深度课程和专题研究可能需要订阅或单独购买。',
        },
      },
      {
        '@type': 'Question',
        name: '如何选择适合自己的学习内容？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过首页的分类导航浏览不同领域的内容，也可以使用搜索功能查找特定主题。我们建议从你最感兴趣的领域开始，逐渐拓展到其他方向。',
        },
      },
      {
        '@type': 'Question',
        name: '文章内容的权威性如何保证？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '所有内容均由领域内具有专业背景的作者撰写，经过编辑团队的多轮审核。我们注重引用可靠的学术来源和实践案例。',
        },
      },
      {
        '@type': 'Question',
        name: '我可以投稿或成为平台作者吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们欢迎有专业知识和独特见解的作者加入。你可以通过关于我们页面的联系方式提交写作样本和研究方向。',
        },
      },
    ],
  };

  return (
    <Layout>
      <SEOHead
        title="含羞草研究院 - 专业知识探索与学习成长平台"
        description="含羞草研究院是一个专注于知识探索、学习成长与自我提升的专业平台。提供深度研究内容、实用学习方法和丰富成长资源，帮助每一位求知者突破自我，开启全新认知旅程。"
        keywords="含羞草研究院,含羞草研究院学习资源,含羞草研究院知识探索,含羞草研究院自我成长,含羞草研究院课程,专业知识研究平台,学习成长社区"
        canonicalUrl="https://www.mimosa-research.cn"
      />
      <SchemaOrg schema={websiteSchema} />
      <SchemaOrg schema={orgSchema} />
      <SchemaOrg schema={faqSchema} />

      <HeroSection />
      <CategoryGrid />
      <FeaturedArticles />
      <FeaturesSection />
      <FAQSection />
      <CTASection />
    </Layout>
  );
}